import { render, staticRenderFns } from "./edit-select-dialog.vue?vue&type=template&id=8501a614&scoped=true&"
import script from "./edit-select-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-select-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8501a614",
  null
  
)

export default component.exports